export const getDocumentReferer = () => {
    return document.referrer || null;
};
